import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { topProgress } from '../services/topProgressService.js'

export const useLoadingStore = defineStore('loading', () => {
  const loadingCount = ref(0)
  const loadingMessage = ref('Memuat data...')
  let safetyTimer = null

  const isLoading = computed(() => loadingCount.value > 0)

  function startLoading(message = 'Memuat data...') {
    loadingCount.value++
    loadingMessage.value = message

    // Trigger instant (0ms) top progress bar on initial loading
    if (loadingCount.value === 1) {
      try {
        topProgress.start()
      } catch (e) {}
    }

    // Extended failsafe timeout (15 seconds) so legitimate data fetching and view rendering
    // are never prematurely aborted, but users are guaranteed never to be stuck indefinitely.
    if (safetyTimer) clearTimeout(safetyTimer)
    safetyTimer = setTimeout(() => {
      console.warn('[LoadingStore] Failsafe timeout reached (15s). Auto-releasing loader.')
      forceStopLoading()
    }, 15000)
  }

  function stopLoading() {
    if (loadingCount.value > 0) {
      loadingCount.value--
    }
    if (loadingCount.value === 0) {
      if (safetyTimer) {
        clearTimeout(safetyTimer)
        safetyTimer = null
      }
      try {
        topProgress.finish(true)
      } catch (e) {}
    }
  }

  function forceStopLoading() {
    loadingCount.value = 0
    if (safetyTimer) {
      clearTimeout(safetyTimer)
      safetyTimer = null
    }
    try {
      topProgress.finish(true)
    } catch (e) {}
  }


  return {
    isLoading,
    loadingMessage,
    startLoading,
    stopLoading,
    forceStopLoading
  }
})
